var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "dialog-base",
        {
          attrs: {
            visible: _vm.visible,
            title: "Chi tiết phiếu thu",
            size: "xl",
            "show-confirm": false,
            "use-panel": false,
            "append-to-body": true,
            top: "4vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            cancel: _vm.handleClose,
          },
        },
        [
          _c("div", { staticClass: "sk-panel mb-3" }, [
            _c("div", { staticClass: "sk-panel-head ird-panel-head" }, [
              _c("div", { staticClass: "sk-panel-icon" }, [
                _c("i", { staticClass: "el-icon-user" }),
              ]),
              _c(
                "div",
                { staticClass: "ird-header-content" },
                [
                  _c("span", { staticClass: "ird-student-name" }, [
                    _vm._v(_vm._s(_vm.studentName)),
                  ]),
                  _vm.currentStatus
                    ? _c(
                        "el-tag",
                        {
                          staticClass: "font-semibold",
                          attrs: {
                            type: _vm.statusTagType(_vm.currentStatus),
                            size: "small",
                            effect: "light",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.statusLabel(_vm.currentStatus)) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("span", { staticClass: "ird-divider" }, [_vm._v("|")]),
                  _c("div", { staticClass: "ird-meta-pill" }, [
                    _c("span", { staticClass: "ird-meta-pill__label" }, [
                      _vm._v("Mã học sinh:"),
                    ]),
                    _c("span", { staticClass: "ird-meta-pill__value" }, [
                      _vm._v(_vm._s(_vm.studentCode)),
                    ]),
                  ]),
                  _c("div", { staticClass: "ird-meta-pill" }, [
                    _c("span", { staticClass: "ird-meta-pill__label" }, [
                      _vm._v("Mã phiếu:"),
                    ]),
                    _c("span", { staticClass: "ird-meta-pill__value" }, [
                      _vm._v(_vm._s(_vm.invoiceCode)),
                    ]),
                  ]),
                  _c("div", { staticClass: "ird-meta-pill" }, [
                    _c("span", { staticClass: "ird-meta-pill__label" }, [
                      _vm._v("Thời gian:"),
                    ]),
                    _c("span", { staticClass: "ird-meta-pill__value" }, [
                      _vm._v(
                        "Tháng " +
                          _vm._s(_vm.selectedInvoice.month) +
                          "/" +
                          _vm._s(_vm.selectedInvoice.year)
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "ird-meta-pill" }, [
                    _c("span", { staticClass: "ird-meta-pill__label" }, [
                      _vm._v("Đợt thu:"),
                    ]),
                    _c("span", { staticClass: "ird-meta-pill__value" }, [
                      _vm._v("Đợt " + _vm._s(_vm.selectedInvoice.turn)),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
            _vm.invoiceData.idx && !_vm.isLoading
              ? _c("div", { staticClass: "ird-kpi-grid mt-3" }, [
                  _c("div", { staticClass: "ird-kpi-card" }, [
                    _c(
                      "div",
                      { staticClass: "ird-kpi-icon ird-kpi-icon--info" },
                      [_c("i", { staticClass: "el-icon-time" })]
                    ),
                    _c("div", { staticClass: "ird-kpi-body" }, [
                      _c("span", { staticClass: "ird-kpi-label" }, [
                        _vm._v("Thiếu / Thừa trước"),
                      ]),
                      _c("strong", { staticClass: "ird-kpi-value" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("formatCurrencyNew")(
                                _vm.invoiceData.beforeMoney
                              )
                            ) +
                            "\n            "
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "ird-kpi-card" }, [
                    _c(
                      "div",
                      { staticClass: "ird-kpi-icon ird-kpi-icon--primary" },
                      [_c("i", { staticClass: "el-icon-money" })]
                    ),
                    _c("div", { staticClass: "ird-kpi-body" }, [
                      _c("span", { staticClass: "ird-kpi-label" }, [
                        _vm._v("Tổng phải thu"),
                      ]),
                      _c(
                        "strong",
                        { staticClass: "ird-kpi-value ird-text-primary" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("formatCurrencyNew")(
                                  _vm.invoiceData.sumMoney
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "ird-kpi-card" }, [
                    _c(
                      "div",
                      { staticClass: "ird-kpi-icon ird-kpi-icon--success" },
                      [_c("i", { staticClass: "el-icon-circle-check" })]
                    ),
                    _c("div", { staticClass: "ird-kpi-body" }, [
                      _c("span", { staticClass: "ird-kpi-label" }, [
                        _vm._v("Đã thanh toán"),
                      ]),
                      _c(
                        "strong",
                        { staticClass: "ird-kpi-value ird-text-success" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("formatCurrencyNew")(
                                  _vm.invoiceData.collectedMoney
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm.invoiceData.cashMoney || _vm.invoiceData.transferMoney
                        ? _c("span", { staticClass: "ird-kpi-subtext" }, [
                            _vm._v(
                              "\n              TM: " +
                                _vm._s(
                                  _vm._f("formatCurrencyNew")(
                                    _vm.invoiceData.cashMoney || 0
                                  )
                                ) +
                                " • CK: " +
                                _vm._s(
                                  _vm._f("formatCurrencyNew")(
                                    _vm.invoiceData.transferMoney || 0
                                  )
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _c("div", { staticClass: "ird-kpi-card" }, [
                    _c(
                      "div",
                      {
                        staticClass: "ird-kpi-icon",
                        class:
                          Number(_vm.invoiceData.afterMoney) < 0
                            ? "ird-kpi-icon--danger"
                            : "ird-kpi-icon--success",
                      },
                      [_c("i", { staticClass: "el-icon-wallet" })]
                    ),
                    _c("div", { staticClass: "ird-kpi-body" }, [
                      _c("span", { staticClass: "ird-kpi-label" }, [
                        _vm._v("Thiếu / Thừa còn lại"),
                      ]),
                      _c(
                        "strong",
                        {
                          staticClass: "ird-kpi-value",
                          class:
                            Number(_vm.invoiceData.afterMoney) < 0
                              ? "ird-text-danger"
                              : "ird-text-success",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm._f("formatCurrencyNew")(
                                  _vm.invoiceData.afterMoney
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "sk-panel sk-panel--flat mt-3" }, [
            _c("div", { staticClass: "sk-panel-head mb-3" }, [
              _c(
                "div",
                { staticClass: "sk-panel-icon sk-panel-icon--success" },
                [_c("i", { staticClass: "el-icon-s-order" })]
              ),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-between flex-wrap gap-2",
                  },
                  [
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Chi tiết các khoản thu"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v(
                          "Bao gồm khoản thu chính và các khoản phụ phân rã trong phiếu thu"
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      [
                        _c(
                          "el-tag",
                          {
                            staticClass: "font-semibold",
                            attrs: {
                              size: "small",
                              type: "primary",
                              effect: "plain",
                            },
                          },
                          [
                            _vm._v(
                              "\n                Tổng số: " +
                                _vm._s(
                                  (_vm.invoiceData.invoiceDetails || []).length
                                ) +
                                " khoản thu\n              "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
            _vm.canEdit
              ? _c("div", { staticClass: "sk-note mb-3" }, [
                  _c("i", { staticClass: "el-icon-info text-base" }),
                  _c("span", [
                    _vm._v("Bấm biểu tượng "),
                    _c("strong", [_vm._v("Sửa")]),
                    _vm._v(" ("),
                    _c("i", { staticClass: "el-icon-edit text-blue-600" }),
                    _vm._v(
                      ") tại khoản thu chính để chỉnh sửa chi tiết và các khoản phụ bên trong."
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.loadError
              ? _c(
                  "div",
                  {
                    staticClass:
                      "sk-note sk-note--danger mb-3 flex items-center justify-between",
                  },
                  [
                    _c("div", { staticClass: "flex items-center gap-2" }, [
                      _c("i", {
                        staticClass: "el-icon-warning-outline text-base",
                      }),
                      _c("span", [_vm._v(_vm._s(_vm.loadError))]),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          size: "mini",
                          type: "danger",
                          plain: "",
                          icon: "el-icon-refresh",
                        },
                        on: { click: _vm.fetchInvoiceDetail },
                      },
                      [_vm._v("Tải lại")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "ird-table-wrapper" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    staticClass: "sk-table",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.detailRows,
                      "row-key": "rowKey",
                      "tree-props": { children: "children" },
                      "default-expand-all": "",
                      border: "",
                      "max-height": "460",
                      "empty-text": "Không có khoản thu trong phiếu",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "Khoản thu",
                        prop: "revenueName",
                        "min-width": "260",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "ird-revenue-cell" },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: {
                                        "font-bold text-slate-800":
                                          !row.isChild,
                                        "text-slate-600": row.isChild,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(row.revenueName) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  row.isChild
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticClass: "ml-1.5 ird-child-tag",
                                          attrs: {
                                            size: "mini",
                                            type: "info",
                                            effect: "plain",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Khoản phụ\n                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Đơn vị",
                        prop: "unit",
                        width: "85",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", { staticClass: "text-slate-600" }, [
                                _vm._v(_vm._s(row.unit || "—")),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Đơn giá",
                        "min-width": "125",
                        align: "right",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c("span", { staticClass: "ird-money" }, [
                                _vm._v(
                                  _vm._s(_vm._f("formatCurrencyNew")(row.price))
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Số lượng",
                        width: "85",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                { staticClass: "font-medium text-slate-700" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.formatQuantity(row.quantity))
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Giảm giá",
                        "min-width": "120",
                        align: "right",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.discount && row.discountType === "PERCENT"
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-amber-600 font-semibold",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(row.discountNumber) +
                                          "%\n              "
                                      ),
                                    ]
                                  )
                                : row.discount
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "text-amber-600 font-semibold",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("formatCurrencyNew")(
                                              row.discountNumber
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "text-slate-400" },
                                    [_vm._v("—")]
                                  ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Thuế",
                        "min-width": "120",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                {
                                  class: {
                                    "text-slate-400": !row.taxPercentage,
                                    "text-slate-700 font-medium":
                                      row.taxPercentage,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.formatTax(row.taxPercentage)) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Thành tiền",
                        "min-width": "135",
                        align: "right",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "strong",
                                { staticClass: "ird-money ird-money--total" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm._f("formatCurrencyNew")(row.amount)
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Mô tả",
                        prop: "description",
                        "min-width": "160",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "span",
                                { staticClass: "text-slate-500 text-xs" },
                                [_vm._v(_vm._s(row.description || "—"))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm.canEdit
                      ? _c("el-table-column", {
                          attrs: {
                            label: "Tác vụ",
                            width: "80",
                            align: "center",
                            fixed: "right",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    !row.isChild
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: "Chỉnh sửa khoản thu",
                                              placement: "top",
                                              enterable: false,
                                            },
                                          },
                                          [
                                            _c("el-button", {
                                              attrs: {
                                                size: "mini",
                                                type: "primary",
                                                icon: "el-icon-edit",
                                                circle: "",
                                                plain: "",
                                                disabled:
                                                  _vm.isLoading || !row.idx,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleEditDetail(
                                                    row
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1732849708
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass: "sk-dialog__footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-cancel",
                  attrs: { plain: "" },
                  on: { click: _vm.handleClose },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close mr-1" }),
                  _vm._v(" Đóng\n      "),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c("edit-invoice-detail-item-dialog", {
        ref: "editInvoiceDetailItemDialog",
        on: { saved: _vm.handleDetailSaved },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }